module.exports = __webpack_public_path__ + "static/factory-8f18514d8ce6adb4d0886f6d3952b907.svg";